<template>
    <div class="about-main-page" v-if="aboutPage != null">
        <aboutUs_section></aboutUs_section>
        <history_section></history_section>
        <choose_section></choose_section>
        <mission_section></mission_section>
        <div class="corp-info-container">
            <promoNews></promoNews>
            <promoProjects></promoProjects>
            <formPage class="form-page-about"></formPage>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import aboutUs_section from '@/components/about/about-us-section.vue'
    import history_section from '@/components/about/history-section.vue'
    import choose_section from '@/components/about/choose-bazis.vue'
    import mission_section from '@/components/about/mission-section.vue'
    import promoNews from '@/components/index-promo/promo-news.vue'
    import promoProjects from '@/components/index-promo/promo-projects.vue'
	import formPage from '@/components/forms/form-page.vue';	

    export default {
        name: 'about--page',
        components: {
            aboutUs_section,
            history_section,
            choose_section,
            mission_section,
            promoNews,
            promoProjects,
            formPage,
        },
        data () {
            return {
                title: 'О компании',
            }
        },
        computed: mapGetters({
            aboutPage: 'loadAboutPage',
            newsItemsDefault: 'loadNewsItemsDefault',
        }),
        methods: {
        },
        beforeRouteEnter (to, from, next) {
            store.dispatch('getNewsItems');
            store.dispatch('getIndexPageData');
            if (store.state.aboutPageArr != null) {
                next(vm => {
                    vm.$store.commit('removePageLoaderImg');
                    setTimeout(() => {
                        vm.$parent.$refs.topProgress.done();
                    }, 300);
                });
            } else {
                store.dispatch('getAboutPageData').then((response) => {
                    if (response) {
                        next(vm => {
                            vm.$store.commit('removePageLoaderImg');
                            setTimeout(() => {
                                vm.$parent.$refs.topProgress.done();
                            }, 300);
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'about';
        },
        created () {
            document.title = this.title;
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about/about-page.scss';
    @import '@/styles/components/about/respond/about-page-respond.scss';
</style>